import Udesk from 'Udesk';
import UdeskLocales from 'UdeskLocales';
import React, { useCallback, useEffect, useState } from 'react';
import { Menu, Popover, Space, Input, Button, Dropdown } from 'udesk-ui';
import Ellipsis from 'src/components/common/Ellipsis';
import Uplaod from 'src/components/pages/components/quality-score/components/Uplaod';
import ComplaintDetail from './components/ComplaintDetail';
import ReviewDetail from './components/ReviewDetail';
import { ReviewTypeMap } from './const';

const Template = React.memo((props) => {
    const locales = UdeskLocales['current'];

    const { visible, complaintInfo, localesReview, showActionsBtn } = props;

    const [reviewType, setReviewType] = useState(ReviewTypeMap.Pass);
    const [popoverVisible, setPopoverVisible] = useState(false);
    const [reviewReason, setReviewReason] = useState('');
    const [attachments, setAttachments] = useState([]);

    useEffect(() => {
        if (props.isTaskChanged) {
            setReviewReason(
                /* 流程质检任务发生变更，请重新申诉。 */ UdeskLocales['current'].components
                    .qualityScore.components.reviewComponent
                    .theProcessQualityInspectionTaskHasChangedPleaseAppealAgain
            );
        } else {
            setReviewReason('');
        }
    }, [props.isTaskChanged]);

    const [isUploading, setIsUploading] = useState(false);

    const onStart = useCallback(() => {
        setIsUploading(true);
    }, []);

    const onFinish = useCallback(() => {
        setIsUploading(false);
    }, []);

    const onUploadChange = useCallback((f) => {
        setAttachments(f);
    }, []);

    if (!visible) return null;

    const onVisibleChange = (type) => {
        setReviewType(type);
        setPopoverVisible(true);
    };
    const onInput = (e) => {
        setReviewReason(e.target.value);
    };

    const onSubmit = () => {
        setPopoverVisible(false);
        reviewType === ReviewTypeMap.Pass
            ? props.onResolve?.({
                  passStatus: ReviewTypeMap.Pass,
                  rejection: reviewReason,
                  attachments,
              })
            : props.onReject?.({
                  passStatus: ReviewTypeMap.Reject,
                  rejection: reviewReason,
                  attachments,
              });
    };

    return (
        <>
            {visible && (
                <div style={{ padding: '0 8px 8px' }}>
                    {/* 申诉 */}
                    <ComplaintDetail complaintInfo={complaintInfo} localesReview={localesReview} />

                    {/* 复核 */}
                    <ReviewDetail complaintInfo={complaintInfo} />

                    {/* 操作 */}
                    {showActionsBtn && (
                        <div style={{ textAlign: 'right', marginTop: 8 }}>
                            <Popover
                                visible={popoverVisible}
                                trigger="click"
                                content={
                                    <div style={{ width: 300 }}>
                                        <div style={{ display: 'flex', marginBottom: 8 }}>
                                            <div style={{ flex: '64px 0 0' }}>
                                                <Ellipsis
                                                    text={
                                                        reviewType === ReviewTypeMap.Pass
                                                            ? /* 通过原因: */ UdeskLocales[
                                                                  'current'
                                                              ].components.qualityScore.components
                                                                  .reviewComponent.index
                                                                  .reasonsForAdoption
                                                            : reviewType === ReviewTypeMap.Reject
                                                            ? /* 驳回原因: */ UdeskLocales[
                                                                  'current'
                                                              ].components.qualityScore.components
                                                                  .reviewComponent.index
                                                                  .reasonForRejection
                                                            : ''
                                                    }
                                                />
                                            </div>

                                            <div style={{ flex: 1, minWidth: 0 }}>
                                                {props.isTaskChanged ? (
                                                    reviewReason
                                                ) : (
                                                    <Input.TextArea
                                                        value={reviewReason}
                                                        onChange={onInput}
                                                        autoSize={{ minRows: 3, maxRows: 3 }}
                                                        maxCount={200}
                                                        maxLength={200}
                                                        showCount={true}
                                                        placeholder={
                                                            /* 请输入原因 */ UdeskLocales['current']
                                                                .components.qualityScore.components
                                                                .reviewComponent.index
                                                                .pleaseEnterAReason
                                                        }
                                                    />
                                                )}
                                            </div>
                                        </div>

                                        <div style={{ display: 'flex', marginBottom: 8 }}>
                                            <div style={{ flex: '64px 0 0' }}>
                                                <Ellipsis
                                                    text={
                                                        /* 附件: */ UdeskLocales['current']
                                                            .components.qualityScore.components
                                                            .reviewComponent.index.attachments
                                                    }
                                                />
                                            </div>

                                            <div style={{ flex: 1, minWidth: 0 }}>
                                                {props.isTaskChanged ? (
                                                    reviewReason
                                                ) : (
                                                    <Uplaod
                                                        value={attachments}
                                                        onChange={onUploadChange}
                                                        accept=".jpg,.jpge,.png,.mp4,.mov,.mp3,.wav,.doc,.docx,.pdf,.xlsx,.xls,.ppt"
                                                        multiple={true}
                                                        maxCount={5}
                                                        onStart={onStart}
                                                        onFinish={onFinish}
                                                    />
                                                )}
                                            </div>
                                        </div>

                                        <div
                                            style={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                marginTop: 8,
                                            }}
                                        >
                                            <Button
                                                size="small"
                                                onClick={() => setPopoverVisible(false)}
                                            >
                                                {locales.labels.cancel}
                                            </Button>

                                            <Button
                                                size="small"
                                                type="primary"
                                                onClick={onSubmit}
                                                disabled={isUploading}
                                            >
                                                {locales.labels.submit}
                                            </Button>
                                        </div>
                                    </div>
                                }
                            >
                                <Space>
                                    {(!complaintInfo.complainStatus ||
                                        [
                                            Udesk.enums.complainStatus.default.id,
                                            Udesk.enums.complainStatus.canceled.id,
                                        ].includes(complaintInfo.complainStatus)) && (
                                        <React.Fragment>
                                            <Button
                                                size="small"
                                                danger
                                                onClick={() =>
                                                    onVisibleChange(ReviewTypeMap.Reject)
                                                }
                                                disabled={
                                                    Udesk.enums.complainStatus.canceled.id ===
                                                    complaintInfo.complainStatus
                                                }
                                            >
                                                {locales.fix.reject}
                                            </Button>
                                            <Button
                                                onClick={() => onVisibleChange(ReviewTypeMap.Pass)}
                                                size="small"
                                                type="primary"
                                                disabled={
                                                    Udesk.enums.complainStatus.canceled.id ===
                                                    complaintInfo.complainStatus
                                                }
                                            >
                                                {locales.fix.pass}
                                            </Button>
                                        </React.Fragment>
                                    )}

                                    {complaintInfo.complainStatus &&
                                        complaintInfo.complainStatus !==
                                            Udesk.enums.complainStatus.default.id && (
                                            <React.Fragment>
                                                <Dropdown
                                                    getPopupContainer={(triggerNode) => triggerNode}
                                                    trigger={['click']}
                                                    overlay={
                                                        <Menu>
                                                            <Menu.Item>
                                                                <Button
                                                                    type="text"
                                                                    onClick={() =>
                                                                        onVisibleChange(
                                                                            ReviewTypeMap.Reject
                                                                        )
                                                                    }
                                                                >
                                                                    {locales.fix.reject}
                                                                </Button>
                                                            </Menu.Item>
                                                            <Menu.Item>
                                                                <Button
                                                                    style={{ width: '100%' }}
                                                                    type="text"
                                                                    onClick={() =>
                                                                        onVisibleChange(
                                                                            ReviewTypeMap.Pass
                                                                        )
                                                                    }
                                                                >
                                                                    {locales.fix.pass}
                                                                </Button>
                                                            </Menu.Item>
                                                        </Menu>
                                                    }
                                                    placement="topCenter"
                                                    disabled={
                                                        Udesk.enums.complainStatus.canceled.id ===
                                                        complaintInfo.complainStatus
                                                    }
                                                >
                                                    <Button size="small" type="primary">
                                                        {locales.fix.revise}
                                                    </Button>
                                                </Dropdown>
                                            </React.Fragment>
                                        )}
                                </Space>
                            </Popover>
                        </div>
                    )}
                </div>
            )}
        </>
    );
});

export default Template;
